import * as React from 'react';
import {
  BackgroundColor,
  BorderColor,
  classNames,
  FontSize,
  Margin,
  Padding,
  TextAlign,
  TextColor
} from '@snoam/pinata';

interface ILoggedInInfoProps {
  spidPrimaryEmail: string;
}

const styleClass = {
  root: classNames(
    BackgroundColor.BG_PRIMARY_LIGHT,
    BorderColor.BORDER_NEUTRAL_3,
    Margin.XS_MX_NEGATIVE_6,
    Margin.MD_MX_NEGATIVE_8,
    Padding.PX_6,
    Padding.MD_PX_10,
    Padding.PY_3,
    FontSize.TEXT_SM,
    TextColor.TEXT_NEUTRAL_7,
    TextAlign.TEXT_CENTER,
  )
};

export class LoggedInInfo extends React.Component<ILoggedInInfoProps> {

  public static displayName = "LoggedInInfo";

  public render() {
    const { pathname } = window.location;

    if (
      pathname.indexOf('/receipt') !== -1 ||
      pathname.indexOf('/upgrade') !== -1 ||
      pathname.indexOf('/duplicate') !== -1
    ) {
      return null;
    }

    const { spidPrimaryEmail } = this.props;
    return (
      <div className={styleClass.root}>
        <span data-testing="shopping-basket-email">
          <span>Du er registrert med: </span>
          {spidPrimaryEmail}
        </span>
      </div>
    );
  }
}

export default LoggedInInfo;
